module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Our country has wide borders; there is no man")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("born has travelled round it. And it bears")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("secrets in its bosom of which no man dreams.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Up here we live two different lives: in the summer,")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("under the torch of the warm sun, and in the")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("winter, under the lash of the north wind.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i')])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("And when the long Darkness spreads itself over the")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("country... men’s thoughts move along devious")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("paths... and many hidden things are revealed.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("— Blind Ambrosius")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83cb9dba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/OPS/section2.vue
// module id = 78
// module chunks = 0